import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Service from "../services/Service";
import Button from '@mui/material/Button';
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
//import MuiAlert from '@material-ui/lab/Alert';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
//import TextField from "@material-ui/core/TextField";
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from '@material-ui/core/InputAdornment';
import PortfolioCard from "./PortfolioCard";
import { useHistory } from 'react-router'


import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import IconButton from '@mui/material/IconButton';
import Select from '@material-ui/core/Select';
import DialogActions from "@material-ui/core/DialogActions";
import _ from 'lodash'
import {useDispatch, useSelector} from "react-redux";
import {editTransaction, getPortfolio, getPortfolios, isEmptyProfile} from "../store/actions";
import {currencies, transactionsType} from "../AppConstants";
import {useFormik} from 'formik';
import * as yup from 'yup';

import CachedIcon from "@mui/icons-material/Cached";
import DialogContentText from "@mui/material/DialogContentText";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Chip from '@mui/material/Chip';
import CardHeader from '@mui/material/CardHeader';
import SvgIcon from '@mui/material/SvgIcon';
import {ReactComponent as TinkIcon} from '../routing/MainPage/img/brokers/tink.svg';
import Grid from '@mui/material/Grid';
import {Link} from "react-router-dom";

const service = new Service();
// const Alert = (props) => {
//     return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

function NumberFormatCustom(props) {
    const {inputRef, onChange, ...other} = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator={' '}
            decimalSeparator={','}
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
const validationSchema = yup.object({
    tt: yup.string()
        .required(
            "Пожалуйста, введите токен"
        ),
});


export default function Tinkoff_API(props) {
    //const isEmptyProfile=props.isEmptyProfile
    const useStyles = makeStyles({});
    const classes = useStyles();
    const history = useHistory();
    const portfolioList = useSelector(store => store.portfolios?.list);
    //const selectedIndex = useSelector(store => store.user.portfolio);
    const data = useSelector(store => store.portfolio?.data)
    //const [portfolio, setPortfolio] = useState(portfolioList[selectedIndex]?.id || undefined)
    useEffect(() => {

        if (!data){
            if (portfolioList.length > 0) {
                dispatch(getPortfolio(portfolioList[0]?.id))
            }
        }
    }, [portfolioList]);

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [accounts, setAccounts] = useState([])
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleDeleteToken = () => {

        service.updatePortfolioPatch({'tt':''}, data?.portfolio.id).then((result) => {
            dispatch(getPortfolio(data?.portfolio.id));
        }).catch(() => {
            alert('Ошибка при отключении');
        });
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
        formik.resetForm()
    };


    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    const formik = useFormik({
        initialValues: {
            tt: '',
            taccountid: undefined,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // alert(JSON.stringify(values, null, 2));
            values.portfolio = data?.portfolio.id
            service.importTinkoffToken(values).then((result) => {
                if (Array.isArray(result.data) && result.data.length > 1){
                    values.taccountid=result.data[0].id
                    setAccounts(result.data)
                } else {
                    setAccounts([])
                    dispatch(getPortfolio(values.portfolio));
                    handleClose()
                    if(isEmptyProfile){
                        history.push('/portfolio')
                    }

                }
            }).catch(() => {
                alert('Ошибка при добавлении');
            });
        },
    });
    return (
        <>
            <Grid >
                <Card variant="outlined">
                    <CardHeader
                        avatar={
                            <SvgIcon>
                                <TinkIcon/>
                            </SvgIcon>
                        }
                        action={
                            <Chip label="New" color="primary" variant="outlined" size="small"/>
                        }
                        title={<p>Интеграция Tinkoff API {data?.portfolio.tt && <Chip label="Подключено" size="small" color="success"
                                                               variant="outlined"/>}</p>}
                        //subheader="September 14, 2016"
                    />
                    <CardActions>
                        {data?.portfolio.tt ?
                            <Button
                                size="small"
                                onClick={handleClickOpen}
                            >
                                Отключить
                            </Button>
                            :
                            <Button
                                size="small"
                                onClick={handleClickOpen}>
                                Подключить
                            </Button>
                        }
                    </CardActions>
                </Card>
            </Grid>
            {data?.portfolio.tt ?
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Отключение интеграции Tinkoff API
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Информация о вашем токене будет удалена, а&#160;все ранее импортированные сделки останутся
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Отмена</Button>
                            <Button onClick={handleDeleteToken} autoFocus>
                                Подтвердить
                            </Button>
                        </DialogActions>
                    </Dialog>
                :

                    <Dialog fullWidth open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Tinkoff API</DialogTitle>
                        <form onSubmit={formik.handleSubmit}>
                            <DialogContent>

                                <DialogContentText id="alert-dialog-description">
                                    <Alert severity="info">
                                        <AlertTitle>Об интеграции</AlertTitle>
                                        <ul>
                                        <li>Мы сохраним ваш токен в зашифрованнном виде и будем использовать только для получения информации о ваших сделках по вашему запросу.</li>
                                        <li>Для последующего обновления данных используйте кнопку синхронизации <CachedIcon sx={{ fontSize: 15 }} /> на верхней панели.</li>
                                        <li>Рекомендуем использовать токен, выпущенный <strong>только для чтения</strong>.</li>

                                        </ul></Alert>

                               </DialogContentText>
                                <br/>
                                <TextField
                                    InputLabelProps={{shrink: true}}
                                    style={{marginBottom: 10}}
                                    type="password"
                                    disabled={!_.isEmpty(accounts)}
                                    //placeholder="Введите токен"
                                    variant="outlined"
                                    fullWidth
                                    id="tt"
                                    name="tt"
                                    label="Токен Tinkoff API"
                                    autoComplete='off'
                                    // InputProps={{
                                    //     inputComponent: NumberFormatCustom,
                                    // }}
                                    value={formik.values.tt}
                                    onChange={formik.handleChange}
                                    error={formik.touched.tt && Boolean(formik.errors.tt)}
                                    helperText={formik.touched.tt && formik.errors.tt}
                                />
                                { !_.isEmpty(accounts) &&
                                    <>
                                    <TextField
                                        style={{marginBottom: 10}}
                                        fullWidth
                                        id="taccountid"
                                        variant="outlined"
                                        name="taccountid"
                                        label="taccountid"
                                        select
                                        label="Брокерский счёт"
                                        InputLabelProps={{shrink: true}}
                                        value={formik.values.taccountid}
                                        onChange={formik.handleChange}
                                        fullWidth
                                    >
                                        {accounts.map((option,index) => (
                                            <MenuItem
                                                //selected={index===0}
                                                key={option.id}
                                                value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    </>
                                }

                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose} color="primary">
                                    Отмена
                                </Button>

                                    {_.isEmpty(accounts)?
                                        <Button color="primary" type="submit">
                                            Ок
                                        </Button>
                                        :
                                        <Button color="primary" type="submit">
                                            Подключить
                                        </Button>
                                    }

                            </DialogActions>
                        </form>
                    </Dialog>
            }
        </>
    );
}